import { render, staticRenderFns } from "./u-select-solo-rounded.vue?vue&type=template&id=78fa42ec&scoped=true&"
import script from "./u-select-solo-rounded.vue?vue&type=script&lang=js&"
export * from "./u-select-solo-rounded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fa42ec",
  null
  
)

export default component.exports